// 获取域名地址的参数
import {getLocationSearch,md5,createNonceStr} from '@/utils/utils';
let token = getLocationSearch().token
//带Token签名
let appKey = 'app_h5';
let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
let timestamp = new Date().getTime();
let random = createNonceStr();
let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
export default{
    token,
    appKey,
    timestamp,
    random,
    sign
}